module.exports = __webpack_public_path__ + "static/img/Group544.98514662.png";